import { User } from "oidc-client-ts";
import { KEYCLOAK_CLIENT_ID, KEYCLOAK_HOST } from "../../constants/constants";

// Where react-oidc-context (oidc-client-ts) keeps the signed-in user; a silent renew rewrites this entry.
export const OIDC_USER_KEY = `oidc.user:${KEYCLOAK_HOST}:${KEYCLOAK_CLIENT_ID}`;

// The bearer is read when the request goes out, never passed as a query argument: a silent renew is then neither a
// new cache key (no re-read, no repeated mutation) nor a stale bearer on a polled or refetched request (B2-01).
export function prepareHeaders(headers) {
  const stored = window.sessionStorage.getItem(OIDC_USER_KEY);
  const token = stored ? User.fromStorageString(stored).access_token : undefined;
  if (token) headers.set("Authorization", `Bearer ${token}`);
  return headers;
}
